import { useContext } from 'react'
import cx from 'classnames'
import CmsPageContext from 'contexts/cms-page-context'
import GoalsDropdown from '../goal-dropdown'
import StarRating from '../common/star-rating'
import AppStore from './app-store'
import GooglePlay from './google-play'
import { useClientReferral } from '../../../../providers/client-referral-provider'
import s from './styles.module.css'
import { HeroMedia } from './hero-media'
import { useClientTrialDays } from 'hooks/use-client-trial-days'
import { getTrialDaysDuration } from 'utilities/stripe'
import { NEW_MOBILE_MAX } from 'constants/breakpoints'
import { useWindowSizeCondition } from 'hooks/use-window-size-condition'

const HeroExperiment = ({ fields, landingPageOptions }) => {
  const { isCoachPage } = useContext(CmsPageContext)
  const { clientFirstName } = useClientReferral()
  const trialDays = useClientTrialDays()
  const isMobile = useWindowSizeCondition(
    ({ width }) => width <= NEW_MOBILE_MAX
  )

  const {
    header,
    subHeader,
    primaryImage,
    mobileImage,
    video,
    options = {},
  } = fields
  const { isFullScreen = false, dropdownMenuPlacement } = options

  const title = header
    .replace('{firstName}', clientFirstName)
    .replace(/^(.*?\s){4}/, '$&\n')
  const subTitle = subHeader
    ?.replace('{firstName}', clientFirstName)
    ?.replace('{period}', getTrialDaysDuration(trialDays))

  return (
    <section
      className={cx(s.container, {
        [s.banner]: isCoachPage,
        [s.fullScreen]: isFullScreen,
      })}>
      <HeroMedia
        imageFields={
          isMobile && mobileImage ? mobileImage?.fields : primaryImage?.fields
        }
        videoFields={video?.fields}
        isFullScreen={isFullScreen}
      />
      <div
        className={cx(s.content, {
          [s.contentFullScreen]: isFullScreen,
        })}>
        <div className={s.leftContent}>
          <div className={s.titleContainer}>
            <h1 className={s.title}>{title}</h1>
            {subTitle && <p className={s.subTitle}>{subTitle}</p>}
          </div>
          <GoalsDropdown
            analyticProps={{ location: 'Hero' }}
            landingPageOptions={landingPageOptions}
            menuPlacement={dropdownMenuPlacement}
          />
        </div>
        <div className={s.mobileReviewsContainer}>
          <div>
            <AppStore />
            <StarRating rating={4.9} className={s.starRating} showRating />
          </div>
          <div>
            <GooglePlay />
            <StarRating rating={4.8} className={s.starRating} showRating />
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroExperiment
